const inputTypes = {
  SEARCHABLE_DROPDOWN: "SearchableDropDown",
  TEXT: "Text",
  DATE: "Date",
  INTEGER_NUMBER: "Integer",
  FLOAT_NUMBER: "FLOAT",
  BOOLEAN: "Boolean",
};

const Company = [
  { id: "UMMT", name: "UMMT" },
  { id: "UMIE", name: "UMIE" },
];
const DebitAccount = [
  { id: "EGP", name: "EGP" },
  { id: "USD", name: "USD" },
  { id: "EUR", name: "EUR" },
];
const approvalNames = [
  { id: "Import_Permit", name: "Import Permit" },
  { id: "Veterinary_import_Permit", name: "Veterinary import Permit" },
  { id: "Agriculture_Import_Permit", name: "Agriculture Import Permit" },
  { id: "Medical_Customs_Release", name: "Medical Customs Release" },
];
const cargoxNames = [
  { id: "BOL", name: "BOL" },
  { id: "PACKING_LIST", name: "PACKING LIST" },
  { id: "INVOICE", name: "INVOICE" },
  { id: "ELECTRONIC_INVOICE", name: "ELECTRONIC INVOICE" },
  { id: "COO", name: "COO" },
  { id: "COA", name: "COA" },
  { id: "EURO1", name: "EURO1" },
];
const cargoxStatuses = [
  { id: "NOT_UPLOADED", name: "Not Uploaded" },
  { id: "PARTIALLY_UPLOADED", name: "Partially Uploaded" },
  { id: "UPLOADED", name: "Uploaded" },
];
const approvalStates = [
  { id: "PENDING", name: "Pending" },
  { id: "APPROVED", name: "Approved" },
  { id: "REJECTED", name: "Rejected" },
  { id: "PENDING_HEALTH_CERTIFICATE", name: "Pending Health Certificate"},
];


const CargoXStatus = [
  { id: "NOT_UPLOADED", name: "NOT UPLOADED" },
  { id: "PARTIALLY_UPLOADED", name: "PARTIALLY UPLOADED" },
  { id: "UPLOADED", name: "UPLOADED" },
];
const Approval = [
  { id: "APPROVED", name: "APPROVED" },
  { id: "REJECTED", name: "REJECTED" },
  { id: "PENDING", name: "PENDING" },
];
const wayOfShippingOptions = [
  { id: "SEA", name: "SEA" },
  { id: "ROAD", name: "ROAD" },
  { id: "AIR", name: "AIR" },
];

const yesOrNoChoice = [
  { id: "YES", name: "YES" },
  { id: "NO", name: "NO" },
];

const State = [
  { id: "WAITING_FOR_DOCUMENTS", name: "WAITING FOR DOCUMENTS" },
  { id: "UNDER_BANK_PROCESS", name: "UNDER BANK PROCESS" },
  { id: "WAITING_FOR_ARRIVAL", name: "WAITING FOR ARRIVAL" },
  { id: "DOCUMENTS_RECEIVED", name: "DOCUMENTS RECEIVED" },
  { id: "READY_FOR_PROCESSING", name: "READY FOR PROCESSING" },
  { id: "UNDER_CLEARANCE", name: "UNDER CLEARANCE" },
  { id: "READY_TO_RELEASE", name: "READY TO RELEASE" },
  { id: "RELEASED", name: "RELEASED" },
  { id: "CANCELLED", name: "CANCELLED" },
  { id: "HAVING_ISSUES", name: "HAVING ISSUES" },
];

const Ports = [
  { id: "ALEXANDRIA", name: "ALEXANDRIA" },
  { id: "DAMIETTA", name: "DAMIETTA" },
  { id: "PORT_SAID", name: "PORT SAID" },
  { id: "OCTOBER", name: "OCTOBER" },
  { id: "ADABIYA", name: "ADABIYA" },
  { id: "DEKHAILA", name: "DEKHAILA" },
  { id: "SAFAGA", name: "SAFAGA" },
  { id: "SOKHNA", name: "SOKHNA" },
  { id: "CAIRO_AIRPORT", name: "CAIRO AIRPORT" },
];
const MaturityType = [
  { id: "INVOICE", name: "INVOICE" },
  { id: "BILL_OF_LADING", name: "BILL OF LADING" },
  { id: "PAID", name: "PAID" },
];
const transactionStatus = [
  { id: "PENDING", name: "PENDING" },
  { id: "AUTHORIZED", name: "AUTHORIZED" },
  { id: "SUBMITTED", name: "SUBMITTED" },
  { id: "PAID", name: "PAID" },
];
const transactionType = [
  { id: "SITE", name: "SITE" },
  { id: "DEFERRED", name: "DEFERRED" },
  { id: "PAID", name: "PAID" },
];

const loadability = [
  { id: "LCL", name: "LCL" },
  { id: "FCL", name: "FCL" },
];

const Currency = [
  { id: "Select Currency", name: "Select Currency" },
  { id: "AUD", name: "AUD" },
  { id: "AED", name: "AED" },
  { id: "CHF", name: "CHF" },
  { id: "CNY", name: "CNY" },
  { id: "EGP", name: "EGP" },
  { id: "EUR", name: "EUR" },
  { id: "GBP", name: "GBP" },
  { id: "INR", name: "INR" },
  { id: "QAR", name: "QAR" },
  { id: "SAR", name: "SAR" },
  { id: "USD", name: "USD" },
  { id: "NOK", name: "NOK" },
  { id: "ZAR", name: "ZAR" },
];
const TransactionTypes = [
  { id: "INVOICE", name: "Invoice" },
  { id: "CLAIM", name: "Claim" },
];
const InvoiceStates = [
  { id: "PENDING", name: "Pending" },
  { id: "SUBMITTED", name: "Submitted" },
  { id: "SCANNED", name: "Scanned" },
  { id: "RELEASED", name: "Released" },
];
const IncoTerm = [
  { id: "CIF", name: "CIF" },
  { id: "C_AND_F", name: "C AND F" },
  { id: "CFR", name: "CFR" },
  { id: "CIP", name: "CIP" },
  { id: "CPT", name: "CPT" },
  { id: "FOB", name: "FOB" },
  { id: "DAP", name: "DAP" },
  { id: "DDP", name: "DDP" },
  { id: "EXW", name: "EXW" },
  { id: "FCA", name: "FCA" },
];

const origins = [
  { id: "ALGERIA", name: "ALGERIA" },
  { id: "ANTWERP", name: "ANTWERP" },
  { id: "AUSTRALIA", name: "AUSTRALIA" },
  { id: "AUSTRIA", name: "AUSTRIA" },
  { id: "BELGIUM", name: "BELGIUM" },
  { id: "BRAZIL", name: "BRAZIL" },
  { id: "BULGARIA", name: "BULGARIA" },
  { id: "CHINA", name: "CHINA" },
  { id: "COLOMBIA", name: "COLOMBIA" },
  { id: "CZECH_REPUBLIC", name: "CZECH REPUBLIC" },
  { id: "DENMARK", name: "DENMARK" },
  { id: "EGYPT", name: "EGYPT" },
  { id: "ETHIOPIA", name: "ETHIOPIA" },
  { id: "FINLAND", name: "FINLAND" },
  { id: "FRANCE", name: "FRANCE" },
  { id: "GERMANY", name: "GERMANY" },
  { id: "GREAT_BRITAIN", name: "GREAT BRITAIN" },
  { id: "GREECE", name: "GREECE" },
  { id: "GUATEMALA", name: "GUATEMALA" },
  { id: "GUINEA_BISSAU", name: "GUINEA BISSAU" },
  { id: "HOLLAND", name: "HOLLAND" },
  { id: "HUNGARY", name: "HUNGARY" },
  { id: "INDIA", name: "INDIA" },
  { id: "INDONESIA", name: "INDONESIA" },
  { id: "IRAN", name: "IRAN" },
  { id: "IRAQ", name: "IRAQ" },
  { id: "IRELAND", name: "IRELAND" },
  { id: "ITALY", name: "ITALY" },
  { id: "JAPAN", name: "JAPAN" },
  { id: "KENYA", name: "KENYA" },
  { id: "KOREA", name: "KOREA" },
  { id: "MALAWI", name: "MALAWI" },
  { id: "MALAYSIA", name: "MALAYSIA" },
  { id: "MEXICO", name: "MEXICO" },
  { id: "MOROCCO", name: "MOROCCO" },
  { id: "NETHERLANDS", name: "NETHERLANDS" },
  { id: "NEW_ZEALAND", name: "NEW ZEALAND" },
  { id: "NORWAY", name: "NORWAY" },
  { id: "OMAN", name: "OMAN" },
  { id: "PAKISTAN", name: "PAKISTAN" },
  { id: "PHILIPPINES", name: "PHILIPPINES" },
  { id: "POLAND", name: "POLAND" },
  { id: "QATAR", name: "QATAR" },
  { id: "REPUBLIC_OF_IRELAND", name: "REPUBLIC OF IRELAND" },
  { id: "ROMANIA", name: "ROMANIA" },
  { id: "ROTTERDAM", name: "ROTTERDAM" },
  { id: "RWANDA", name: "RWANDA" },
  { id: "SAUDI_ARABIA", name: "SAUDI ARABIA" },
  { id: "SINGAPORE", name: "SINGAPORE" },
  { id: "SLOVAKIA", name: "SLOVAKIA" },
  { id: "SOUTH_AFRICA", name: "SOUTH AFRICA" },
  { id: "SOUTH_KOREA", name: "SOUTH KOREA" },
  { id: "SPAIN", name: "SPAIN" },
  { id: "SWEDEN", name: "SWEDEN" },
  { id: "SWITZERLAND", name: "SWITZERLAND" },
  { id: "TAIWAN", name: "TAIWAN" },
  { id: "TANZANIA", name: "TANZANIA" },
  { id: "THAILAND", name: "THAILAND" },
  { id: "TUNISIA", name: "TUNISIA" },
  { id: "TURKEY", name: "TURKEY" },
  { id: "UGANDA", name: "UGANDA" },
  { id: "UNITED_ARAB_EMIRATES", name: "UNITED ARAB EMIRATES" },
  { id: "UNITED_KINGDOM", name: "UNITED KINGDOM" },
  { id: "UNITED_STATES", name: "UNITED STATES" },
  { id: "VIETNAM", name: "VIETNAM" },
  { id: "CYPRUS", name: "CYPRUS" },
  { id: "CANADA", name: "CANADA" },
];

const paymentTypes = [
  { id: "Select Payment Type", name: "Select Payment Type" },
  { id: "CUSTOMS_FEES", name: "Customs Fees" },
  {
    id: "SECURITY_AND_FLOOR_SPACE_CHARGES",
    name: "Security And Floor Space Charges",
  },
  { id: "LEGAL_POST_AUDIT_CASES", name: "Legal Post Audit Cases" },
  { id: "DISCHARGE", name: "Discharge" },
  { id: "CLEARANCE_FEES", name: "Clearance Fees" },
  { id: "TRANSPORTATION", name: "Transportation" },
  { id: "FREIGHT", name: "Freight" },
  { id: "SYASAT", name: "Syasat" },
  { id: "DEMURRAGE", name: "Demurrage" },
  { id: "FEDERATION_UNION_FEES", name: "Federation Union Fees" },
  { id: "STORAGE", name: "Storage" },
  { id: "MEDICAL_STAMPS", name: "Medical Stamps" },
  { id: "REGISTRATION", name: "Registration" },
  { id: "LEGALIZATION", name: "Legalization" },
  { id: "LEGAL_SUBSCRIPTIONS", name: "Legal Subscriptions" },
];

const documentNames = [
  { id: "BOL", name: "BOL" },
  { id: "INVOICE", name: "Invoice" },
  { id: "PACKING_LIST", name: "Packing List" },
  { id: "COO", name: "COO" },
  { id: "COH", name: "COH" },
  { id: "FORM_4", name: "Form 4" },
  { id: "COA", name: "COA" },
  { id: "EURO1", name: "EURO1" },
  { id: "HEALTH_RELEASE_CERTIFICATE", name: "Health Release Certificate" },
  { id: "PHYTOSANITARY_CERTIFICATE", name: "Phytosanitary Certificate" },
  { id: "SET_OF_DOCUMENTS", name: "Set of Documents" },
];
const EXPORT_COLUMN_OPTIONS = [
  "Category",
  "Po Number",
  "Agent",
  "Way Of Shipping",
  "Planner",
  "Supplier",
  "Material",
  "HS Code",
  "Origin",
  "Relative Company",
  "PFI Receival Date",
  "State",
  "ACID Number",
  "ACID Creation Date",
  "Gross Weight",
  "Net Weight",
  "BOL Number",
  "BOL Date",
  "Port Of Arrival",
  "Shipping Line",
  "Container 20",
  "Container 40",
  "Pallets",
  "Boxes",
  "Booking Number",
  "Shipping Port",
  "Shipped Onboard Date",
  "Form4 Sending Date",
  "Form4 Receival Date",
  "Invoice Date",
  "Invoice Number",
  "Invoice Amount",
  "Invoice Currency",
  "Release Date",
  "Storage Location",
  "Warehouse",
  "Warehouse Arrival Date",
  "IBD Number",
  "Expected Arrival Date",
  "Actual Arrival Date",
  "Customs Approval Date",
  "Custom Certificate",
  "Customs Release Date",
  "Bank",
  "PO Amount",
  "PO Currency",
  "Maturity Type",
  "Maturity Period",
  "Inco Term",
  "Maturity Date",
  "Pending On",
  "IBD Date",
  "FOD",
  "Transaction Type",
  "Authorization Date",
  "Expected Release Date",
  "Bank Linkage",
  "Shipping Country",
  "Loadability",
  "Drums",
  "General Comment",
  "Non Relevant",
  "Created By",
  "Is Sample",
  "Storage Date",
  "Order Number",
  "IDC Number",
  "Trucks Numbers",
  "Transportation Remarks",
  "Time Of Loading",
  "Warehouse Entry",
  "Warehouse Exit",
  "Transaction Status",
  "Payment Date",
  "Debit Account",
  "Exchange Rate",
  "Debit Value",
  "Transaction Comments",
];
const TRANSACTION_EXPORT_COLUMN_OPTIONS = [

  "PO Number",
  "Supplier",
  "Bank",
  "Invoice Number",
  "Invoice Amount",
  "Invoice Currency",
  "Invoice Date",
  "Bol Date",
  "Maturity Period",
  "Maturity Type",
  "Maturity Date",
  "Form 4 Sending Date",
  "Form 4 Receival Date",
  "Upload On Portal Date",
  "Authorization Date",
  "IDC Number",
  "Proceeded Manually",
  "Cora ID",
  "Transaction Status",
  "Payment Date",
  "Debit Account",
  "Exchange Rate",
  "Debit Value",
  "Transaction Comments",
  "Transaction Type",
  "Actual Arrival Date",
  "Expected Arrival Date",
  "Customs Release Date",
];



export {
  inputTypes,
  TransactionTypes,
  IncoTerm,
  MaturityType,
  State,
  documentNames,
  Company,
  CargoXStatus,
  Approval,
  Currency,
  paymentTypes,
  wayOfShippingOptions,
  Ports,
  approvalNames,
  approvalStates,
  cargoxNames,
  cargoxStatuses,
  transactionType,
  loadability,
  yesOrNoChoice,
  InvoiceStates,
  origins,
  DebitAccount,
  transactionStatus,
  EXPORT_COLUMN_OPTIONS,
  TRANSACTION_EXPORT_COLUMN_OPTIONS,
};
